var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-grid p-fluid p-justify-center p-nogutter"},[_c('Toast',{attrs:{"position":"bottomright"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }